import request, { ApiResponse } from './request';

export interface User {
  id: number;
  username: string;
  created_at?: string;
}

export interface LoginForm {
  username: string;
  password: string;
}

export interface LoginResult {
  token: string;
  user: User;
}

export function login(data: LoginForm): Promise<ApiResponse<LoginResult>> {
  return request.post('/auth/login', data);
}

export function getMe(): Promise<ApiResponse<User>> {
  return request.get('/auth/me');
}
